(function ()
{
  $(document).ready(function ()
  {
    $(document).on("swell:initialized", function ()
    {
      campaignsList();
    });
    $(document).on("swell:setup", function ()
    {
      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
      SwellConfig.Referral.populateRedemptionOffers();
      removeLoader("refer");
      $(".swell-post-checkout").css("display", "flex");
      removeLoader("campaign");
      $(".way-to-earn .earn-holder").css("display", "block");
      Swell.Redemption.initializeRedemptions(".swell-redemption-option-list", SwellConfig.Redemption.opts);
      removeLoader("redemption");
      SwellConfig.Tier.initializeDummyTier();
      SwellConfig.Tier.initializeCustomTierProperties();
      SwellConfig.Tier.initializeTiers(".swell-tier-table");
      SwellConfig.Tier.setupSlickSlider();
      removeLoader("tiers");
    });
    $(document).on("swell:customer:updated", function ()
    {
      spapi.refreshCustomerDetails();

    });
    $('body').on("click", ".newsletter-campaign", function (e)
    {
      if (spapi.authenticated)
      {
        if (spapi.customer.perks.map(perk => perk.campaign.type).indexOf("NewsletterSignupCampaign") == -1) {
          swellAPI.showPopupByType("EmailCapturePopup");
          e.stopPropagation();
        }
        else {
          $(".swell-modal").css("display", "flex");
          $(".swell-modal .modal-dialog .modal-content .modal-header-custom #swell-reward-heading").html("Newsletter Signup");
          $(".swell-modal .modal-dialog .modal-content .modal-body #swell-reward-intro").html("Looks like you've already signed up for our newsletter.");
        }
      }
    });
    $("body").on("click",".close", function() {
      $(".swell-modal").css("display", "none");
    });
    var clipboard = new ClipboardJS('#copy-link-button');
    $(document).on("swell:referral:success", function ()
    {
      swellAPI.refreshCustomerDetails(function ()
      {
        $(".table-data").html("");
        SwellConfig.Referral.populateRedemptionOffers();
      });
    });
    $(document).on("swell:referral:error", function (jqXHR, textStatus, errorThrown)
    {
      if (textStatus && textStatus === "EMAILS_ALREADY_PURCHASED")
      {
        $(".refer-customer-error").remove();
        $(".swell-referral-form-list").before('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
      }
      if (textStatus && textStatus === "Please enter a valid email address")
      {
        $(".refer-customer-error").remove();
        $(".swell-referral-form-list").before('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
      }
    });
    $("body").on("click", ".checkout-heading .swell-referral-back-link", function ()
    {
      $(".swell-post-checkout").css("display", "none");
    });
  });
}).call(this);

(function ()
{
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Referral = {
    opts:
    {
      localization:
      {
        referralSidebarDetailsAction: "",
        referralSidebarDetailsReward: "<%= referralCampaign.reward_text %>",

        referralRegisterHeading: "Give $20, get $20",
        referralRegisterFormDetails: "Enter your email to get started.",
        referralRegisterFormEmail: "Enter email",
        referralRegisterFormSubmit: "NEXT",
        referralRegisterDetails: "Give your friends $20 off their first order of $150+ and get $20 for each successful referral.",

        referralReferHeading: "Give $20, get $20",
        referralReferFormEmails: "Your friends’ emails (separated by commas)",
        referralReferFormSubmit: "SEND",
        referralReferFormDetails: "You can refer your friends via email. To get started, enter their email below:",
        referralReferFormEmailsDetails: "",
        referralReferDetails: "Give your friends $20 off their first order of $150+ and get $20 for each successful referral.",
        referralReferMediaDetails: "You can also share your link with the buttons below.",

        referralShareFacebook: "Share",
        referralShareTwitter: "Tweet",
        referralShareCopy: "Copy Link",
        referralShareMessenger: "Message",
        referralShareSMS: "SMS",

        referralReferMediaIcon: "swell-referral-media-icon swell-icon-facebook-share-mob",
        referralTwitterIcon: "swell-referral-media-icon swell-icon-tweet-mob",
        referralLinkIcon: "swell-referral-media-icon swell-icon-copy-link-mob",
        referralMessengerIcon: "swell-referral-media-icon swell-icon-fb-message-mob",
        referralSMSIcon: "swell-referral-media-icon swell-icon-sms-mob",

        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: "Remind your friends to check their emails.",

        referralCopyHeading: "",
        referralCopyButton: "Copy Link",
        referralCopyDetails: "Copy link and share with your friends."
      },
      templates:
      {
        referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><%=localization.referralRegisterHeading%></h2> <p class="swell-referral-details"><%= localization.referralRegisterDetails %></p> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralRegisterFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email"  name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail%>"> </li> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%=  localization.referralRegisterFormSubmit%>"> </li> </ul> </div> </form> </div> </div>',
        referralRefer: "<div class='swell-referral-refer'> <h2 class='swell-referral-heading'><%=localization.referralReferHeading%></h2> <p class='swell-referral-details'><%=localization.referralReferDetails%></p> <div class='swell-referral-form-wrapper'> <form class='swell-referral-form' name='swell-referral-refer-form' id='swell-referral-refer-form' method='POST' action='.'> <div class='swell-referral-form-header'> <p class='swell-referral-form-header-details'><%= localization.referralReferFormDetails %></p> </div> <div class='swell-referral-form-body'> <ul class='swell-referral-form-list'> <li class='swell-referral-form-list-field'> <input class='swell-referral-form-list-field-input' type='text' name='swell-referral-refer-emails' id='swell-referral-refer-emails' required='required' placeholder='<%=localization.referralReferFormEmails%>'> </li> <li class='swell-referral-form-list-field'><input class='swell-referral-form-list-submit' type='submit' name='swell-referral-refer-submit' id='swell-referral-refer-submit' value='<%=localization.referralReferFormSubmit%>'> </li> </ul> </div> </form> </div> <div class='swell-referral-media-wrapper'> <p class='swell-referral-media-details'><%= localization.referralReferMediaDetails %></p> <ul class='swell-referral-media-list'> <li class='swell-referral-medium swell-share-referral-facebook'> <div class='swell-referral-medium-content'> <i class='<%= localization.referralReferMediaIcon %>' aria-hidden='true'></i><%= localization.referralShareFacebook %></div> </li> <li class='swell-referral-medium swell-share-referral-sms'> <div class='swell-referral-medium-content'> <i class='<%= localization.referralSMSIcon %>' aria-hidden='true'></i><%= localization.referralShareSMS %></div> </li> <li class='swell-referral-medium swell-share-referral-twitter'> <div class='swell-referral-medium-content'> <i class='<%= localization.referralTwitterIcon %>' aria-hidden='true'></i><%= localization.referralShareTwitter %></div> </li> <li class='swell-referral-medium swell-share-referral-messenger'> <div class='swell-referral-medium-content'> <i class='<%= localization.referralMessengerIcon %>' aria-hidden='true'></i><%= localization.referralShareMessenger %></div> </li> </ul> </div> <div class='swell-copy-title'>If you want to refer a friend in another way that's not listed above, copy your unique link and share it however you'd like!</div> <div class='swell-custom-copy-link'> <div class='copy-details'> Here’s your referral link: <span class='swell-copy-link swell-referral-link' id='swell-copy-link'></span> </div> <button class='copy-link-button' id='copy-link-button' data-clipboard-target='#swell-copy-link'><%=localization.referralCopyButton%></button> </div> </div>"
      }
    },
    populateRedemptionOffers: function ()
    {
      var receipts = spapi.customer.referral_receipts;
      var email;
      var completed_at;
      var status;
      var rewards_points;
      var count = 0;
      if (receipts)
      {
        receipts.forEach(function (ref_receipts)
        {
          email = ref_receipts.email;
          completed_at = ref_receipts.completed_at;
          rewards_points = spapi.activeReferralCampaign.reward_text;
          if (completed_at)
          {
            status = "purchased (" + rewards_points + " earned)";
            count++;

          }
          else
          {
            status = "invited";
          }
          $(".table-data").append("<tr> <td> " + email + "</td> <td>" + status + "</td></tr>");
        });
      }
    }
  };
}).call(this);

function campaignsList()
{
  var campaigns = spapi.activeCampaigns;
  campaigns.forEach(function (campaign)
  {
    if (campaign.type != "ReferralCampaign")
    {
      $('.swell-campaign-list').append('<li class="swell-campaign swell-campaign-link"  data-display-mode="modal" data-campaign-id="' + campaign.id + '"> <div class="swell-campaign-content"> <div class="swell-campaign-icon"> <span class="swell-campaign-icon-content"> <span class=' + campaign.icon + '></span></span> </div> <div class="swell-campaign-value"> <span class="swell-campaign-value-content">' + campaign.reward_text + '</span> </div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content">' + campaign.title + '</span> </div> </div> <div class="swell-campaign-hover"> <ul class="swell-link-list"> <li class="swell-link"> <a href="/account/login" class="swell-signin-btn">Sign In</a> </li> <li class="swell-link"> <a href="/account/register" class="signup-btn">Sign Up</a> </li> </ul> </div> </li>');
    }

  });
  $('.swell-campaign-list').append('<li class="swell-campaign newsletter-campaign swell-campaign-link"  data-display-mode="modal" data-campaign-id=""> <div class="swell-campaign-content"> <div class="swell-campaign-icon"> <span class="swell-campaign-icon-content"> <span class="swell-icon-Newsletter"></span></span> </div> <div class="swell-campaign-value"> <span class="swell-campaign-value-content">25 Points</span> </div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content">Newsletter Signup</span> </div> </div> <div class="swell-campaign-hover"> <ul class="swell-link-list"> <li class="swell-link"> <a href="/account/login" class="swell-signin-btn">Sign In</a> </li> <li class="swell-link"> <a href="/account/register" class="signup-btn">Sign Up</a> </li> </ul> </div> </li>');
  $('.swell-campaign-list').append('<li class="swell-campaign swell-custom-campaign"> <div class="swell-custom-campaign-holder"> <h2 class="custom-campaign-heading">Give $20, get $20</h2> <p class="custom-campaign-detail">Give your friends $20 off<br class="mobile"> on their first order<br class="desktop"> of $150+ and get $20 for each successful referral.</p> <a href="/pages/refer" class="start-refer">Start referring Now</a> </div> </li>');
};

(function ()
{
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Redemption = {
    opts:
    {
      templates:
      {
        redemptionOption: '<li class="redemption swell-redemption-option"> <div class="swell-redemption-option-content redemption-content" data-redemption-option-id="<%= redemption.id %>"> <div class="swell-redemption-option-cost "><%= redemption.name %></div> <div class="swell-redemption-option-value"><%= redemption.cost_text %></div> <div class="swell-campaign-hover"> <ul class="swell-link-list"> <li class="swell-link"> <a href="/account/login" class="swell-signin-btn">Sign In</a> </li> <li class="swell-link"> <a href="/account/register" class="signup-btn">Sign Up</a> </li> </ul> </div> </div> </li>'
      }
    }
  };
}).call(this);

(function ()
{
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Tier = {
    getCustomerTierRank: function ()
    {
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier && customer_tier.id)
      {
        rank = jQuery.grep(tiers, function (e)
        {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      }
      else
      {
        intro_tier = jQuery.grep(tiers, function (e)
        {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0)
        {
          return intro_tier[0].rank;
        }
        else
        {
          return null;
        }
      }
    },
    getCustomerTierId: function ()
    {
      var customer_tier, intro_tier, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier)
      {
        return customer_tier.id;
      }
      else
      {
        intro_tier = jQuery.grep(tiers, function (e)
        {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0)
        {
          return intro_tier[0].id;
        }
        else
        {
          return null;
        }
      }
    },
    getTierByRank: function (rank)
    {
      var tiers;
      tiers = spapi.activeVipTiers;
      return jQuery.grep(tiers, function (e)
      {
        return e.rank === rank;
      })[0];
    },
    initializeDummyTier: function ()
    {
      var k, len, tier, tiers;
      tiers = spapi.activeVipTiers;
      for (k = 0, len = tiers.length; k < len; k++)
      {
        tier = tiers[k];
        tier.rank += 1;
      }
      return tiers.unshift(
      {
        id: -1,
        rank: 0,
        spendPoints: "<span>Spend: $0 - $" + ((spapi.activeVipTiers[0].amount_spent_cents / 100) - 1) + "</span>per Rolling year",
        namePoints: "Bronze",
        benefit1: "1 Point",
        benefit2: "",
        benefit3: "",
        benefit4: "",
        benefit5: "",
        benefit6: "",
        benefit7: "",
        swellrequiredAmountSpentCents: 0,
        swellrequiredPointsEarned: 0,
        swellrequiredPurchasesMade: 0,
        swellrequiredReferralsCompleted: 0
      });
    },
    initializeCustomTierProperties: function ()
    {

      spapi.activeVipTiers[1].spendPoints = "<span>Spend: $" + (spapi.activeVipTiers[1].amount_spent_cents / 100) + " - $" + ((spapi.activeVipTiers[2].amount_spent_cents / 100) - 1) + "</span>per Rolling year",
      spapi.activeVipTiers[1].namePoints = spapi.activeVipTiers[1].name,
      spapi.activeVipTiers[1].benefit1 = "1.25 Points",
      spapi.activeVipTiers[1].benefit2 = "<div class='swell-circle'></div>",
      spapi.activeVipTiers[1].benefit3 = "<div class='swell-circle'></div>",
      spapi.activeVipTiers[1].benefit4 = "",
      spapi.activeVipTiers[1].benefit5 = "",

      spapi.activeVipTiers[2].spendPoints = "<span>Spend: $" + (spapi.activeVipTiers[2].amount_spent_cents / 100) + " - $" + ((spapi.activeVipTiers[3].amount_spent_cents / 100) - 1) + "</span>per Rolling year",
      spapi.activeVipTiers[2].namePoints = spapi.activeVipTiers[2].name,
      spapi.activeVipTiers[2].benefit1 = "1.5 Points",
      spapi.activeVipTiers[2].benefit2 = "<div class='swell-circle'></div>",
      spapi.activeVipTiers[2].benefit3 = "<div class='swell-circle'></div>",
      spapi.activeVipTiers[2].benefit4 = "<div class='swell-circle'></div>",
      spapi.activeVipTiers[2].benefit5 = "",

      spapi.activeVipTiers[3].spendPoints = "<span>Spend: $" + (spapi.activeVipTiers[3].amount_spent_cents / 100) + "+</span>lifetime spend",
      spapi.activeVipTiers[3].namePoints = spapi.activeVipTiers[3].name,
      spapi.activeVipTiers[3].benefit1 = "1.5 Points",
      spapi.activeVipTiers[3].benefit2 = "<div class='swell-circle'></div>",
      spapi.activeVipTiers[3].benefit3 = "<div class='swell-circle'></div>",
      spapi.activeVipTiers[3].benefit4 = "<div class='swell-circle'></div>",
      spapi.activeVipTiers[3].benefit5 = "<div class='swell-circle'></div>"
    },
    initializeTiers: function (containerSelector)
    {
      var count = 1;
      tiers = spapi.activeVipTiers;
      $(containerSelector).append("<li class='titles-col'> <span class='name-item'>Benefits</span> <span class='list-point-one'>Per $1 Spent</span> <span class='list-point-two'>Early Access to New Products</span> <span class='list-point-three'>In-Store Surprise (varies based on tier)<div class='next-line'>*valid once per rolling year</div></span><span class='list-point-four'>Free Domestic Ground Shipping</span> <span class='list-point-five'>Concierge Service</span></li>");
      $(containerSelector).append("<li class='tier-holder'></li>");
      tiers.forEach(function (tier)
      {
        $(".tier-holder").append("<div data-tier-id=" + tier.id + " class = 'tier-" + count + "-col tier-list-item'> <span class='name-item'>" + tier.namePoints + "</span> <span class='points-item'>" + tier.spendPoints + "</span> <span class='multiplier-item'>" + tier.benefit1 + "</span> <span>" + tier.benefit2 + "</span> <span>" + tier.benefit3 + "</span> <span>" + tier.benefit4 + "</span> <span>" + tier.benefit5 + "</span></div>");
        count++;
      });
      if (spapi.authenticated)
      {
        SwellConfig.Tier.setupCustomerTierStatus();
      }
    },
    setupCustomerTierStatus: function ()
    {
      var toGoNext, next_tier;
      var last_tier = spapi.activeVipTiers.length;
      var last_tier_rank = SwellConfig.Tier.getTierByRank(last_tier - 1);
      $(".swell-tier-table .titles-col, .swell-tier-table .tier-holder .tier-list-item").prepend("<div class='current-status'></div>");
      if (spapi.customer.vip_tier)
      {
        var $customer_tier_id, $customer_tier_rank;
        customer_tier_id = SwellConfig.Tier.getCustomerTierId();
        customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
        tiers = spapi.activeVipTiers;
        tiers.forEach(function (tier)
        {
          if (tier.id == customer_tier_id)
          {
            customer_tier = tier;
          }
        });
        if (last_tier_rank.rank == customer_tier_rank)
        {
          tiers.forEach(function (tier)
          {
            if (tier.rank == customer_tier.rank)
            {
              $("div[data-tier-id='" + tier.id + "'] .current-status").append("Current Status");
            }
          });
        }
        else
        {
          next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
          toGoNext = (next_tier.amount_spent_cents - spapi.customer.vip_tier_stats.amount_spent_cents) / 100;
          if (toGoNext < 0)
          {
            toGoNext = 0;
          }
          tiers.forEach(function (tier)
          {
            if (tier.rank == customer_tier.rank)
            {
              $("div[data-tier-id='" + tier.id + "'] .current-status").append("Current Status");
              $("div[data-tier-id='" + next_tier.id + "'] .current-status").append("<div class='spend-more'>Spend $" + toGoNext + " more to earn " + next_tier.name + "</div>");

            }
          });
        }
      }
      else
      {
        next_tier = SwellConfig.Tier.getTierByRank(1);
        toGoNext = (next_tier.amount_spent_cents - spapi.customer.vip_tier_stats.amount_spent_cents) / 100;
        if (toGoNext < 0)
        {
          toGoNext = 0;
        }
        $("div[data-tier-id='-1'] .current-status").append("Current Status");
        $("div[data-tier-id='" + next_tier.id + "'] .current-status").append("<div class='spend-more'>Spend $" + toGoNext + " more to earn " + next_tier.name + "</div>");
      }
    },
    setupSlickSlider: function ()
    {
      $('.swell-tier-table .tier-holder').slick(
      {
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: null,
        prevArrow: null,
        arrows: false,
        dots: false,
        responsive: [
        {
          breakpoint: 768,
          settings:
          {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
          }
        }]
      });
    }
  }
}).call(this);

function removeLoader(section)
{
  $(".swell-loader-spinner." + section).remove();
}
